import {
  Box,
  Button,
  Divider,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { APP_ICONS } from "../../assets";
import AppContainer from "../../components/containers/AppContainer";
import CustomBar from "../../components/customBar";
import DynamicTable from "../../components/dynamicTable";
import Loader from "../../components/loader";
import SelectInput from "../../components/select";
import TextInput from "../../components/textInput";
import { fetchAllUsers, updateUserStatus } from "../../services/User";
import { constants } from "../../theme/Variables";
import NavigationDrawer from "./../../components/navigationDrawer/index";

const selectInputWith = {
  width: { xs: "100%", md: "150px" },
};

const tableHeader = [
  "USER #ID",
  "USER NAME",
  "EMAIL",
  "PHONE",
  "JOINED ON",
  "STATUS",
  "ACTION",
];

const displayRows = [
  "user_id",
  "user_data",
  "email",
  "phone",
  "created_at",
  "vendor_status",
  "actions",
];

const headersForCsv = [
  { label: "USER #ID", key: "_id" },
  { label: "USER NAME", key: "name" },
  { label: "EMAIL", key: "email" },
  { label: "PHONE", key: "phoneNumber" },
  { label: "JOINED ON", key: "createdAt" },
  { label: "STATUS", key: "status" },
];

const UsersPage = () => {
  const [filterByStatus, setFilterByStatus] = useState("All");
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    handleFetchAllUsers();
  }, []);

  useEffect(() => {
    filterAndSearchUsers();
  }, [filterByStatus, searchValue, allUsers]);

  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({
      snackType: type,
      snackMessage: message,
    });
  };

  const handleFetchAllUsers = async () => {
    try {
      setIsLoading(true);
      const response = await fetchAllUsers();
      setIsLoading(false);
      if (response.status === 200 || response.status === 201) {
        setAllUsers(response?.data?.data || []);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleOpenSnackBar("error", error?.response?.data?.message || "Error");
    }
  };

  const handleUpdateStatus = async (item, status) => {
    try {
      setIsLoading(true);
      const response = await updateUserStatus(item?._id, { status });
      setIsLoading(false);
      if (response.status === 200 || response.status === 201) {
        handleOpenSnackBar("success", response.data.message);
        handleFetchAllUsers();
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleOpenSnackBar("error", error?.response?.data?.message || "Error");
    }
  };

  const filterAndSearchUsers = () => {
    let filteredData = [...allUsers];

    if (filterByStatus !== "All") {
      filteredData = filteredData.filter(
        (user) => user.status === filterByStatus
      );
    }

    if (searchValue.trim()) {
      filteredData = filteredData.filter(
        (user) =>
          user?.name?.toLowerCase().includes(searchValue.toLowerCase()) ||
          user.email?.toLowerCase().includes(searchValue.toLowerCase())
      );
    }

    setFilteredUsers(filteredData);
  };

  return (
    <NavigationDrawer>
      <CustomBar title="USERS" />
      <AppContainer>
        <Stack
          px={3}
          py={2}
          gap={2}
          direction={{ md: "row" }}
          alignItems="center"
        >
          <TextInput
            sx={{ flex: 1 }}
            placeholder="Search Users"
            InputStartIcon={<img src={APP_ICONS.searhIcon} width={20} />}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <Stack
            direction={{ sm: "row" }}
            width="100%"
            flex={2}
            gap={2}
            justifyContent={{ md: "flex-end" }}
          >
            <SelectInput
              placeholder="Sort by status"
              formStyleProps={selectInputWith}
              value={filterByStatus}
              onChange={(e) => setFilterByStatus(e.target.value)}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="InActive">InActive</MenuItem>
            </SelectInput>
          </Stack>
          <CSVLink
            data={filteredUsers}
            headers={headersForCsv}
            filename="filtered-users.csv"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <Box
              height={40}
              bgcolor={"#003B95"}
              borderRadius={2}
              sx={{ width: { xs: "100%", md: 120 } }}
            >
              <Button>
                <Typography color="#FFF">Export</Typography>
              </Button>
            </Box>
          </CSVLink>
        </Stack>

        <Divider />
        {filteredUsers.length > 0 ? (
          <DynamicTable
            tableHeader={tableHeader}
            displayRows={displayRows}
            tableData={filteredUsers}
            showPagination
            showUserMenu
            handleUpdateStatus={handleUpdateStatus}
          />
        ) : (
          <Typography
            color="black"
            fontSize={14}
            fontWeight={700}
            textAlign="center"
            padding="30px 0"
          >
            No Users Found!
          </Typography>
        )}
      </AppContainer>
      <Loader isloading={isLoading} />
    </NavigationDrawer>
  );
};

export default UsersPage;
